module.exports = __webpack_public_path__ + "assets/62d3e37eab387e587c841d2f1813a468.svg";